import { SignPageBase } from '@xbcb/form-components';
import { ImportSignDocs } from '@xbcb/document-components';
import attribution from 'assets/attribution.txt';

const SignPage = () => (
  <SignPageBase attribution={attribution} Docs={ImportSignDocs} />
);

export default SignPage;
